(() => {
  // Keep LP anchors deterministic with the theme's optional Lenis controller.
  document.addEventListener('click', event => {
    const link = event.target.closest('.lp-dobra a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    const menu = link.closest('details');
    if (menu) menu.open = false;
    const controller = document.querySelector('lenis-bar')?.lenis;
    if (controller) controller.scrollTo(target, { immediate: true, force: true });
    else window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: 'instant' });
    history.replaceState(history.state, '', link.getAttribute('href'));
    try {
      if (link.hasAttribute('data-lp-cta')) window.Shopify?.analytics?.publish('custom_event', {
        event_name: 'lp_cta_click', botao: link.getAttribute('data-lp-cta') || '', secao: link.getAttribute('data-lp-section') || ''
      });
    } catch (_) { /* Tracking must never block navigation. */ }
  }, true);
  const init = (scope = document) => {
    scope.querySelectorAll('.lp-faq-item').forEach(item => {
      const button = item.querySelector('.lp-faq-pergunta');
      const answer = item.querySelector('.lp-faq-resposta');
      if (!button || !answer || button.dataset.lpBound) return;
      button.dataset.lpBound = 'true';
      const id = `lp-answer-${Math.random().toString(36).slice(2)}`;
      answer.id = id;
      button.setAttribute('aria-controls', id);
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        answer.hidden = expanded;
      });
    });
    scope.querySelectorAll('.lp-ing-tabs,.lp-cmp-tabs').forEach(list => {
      if (list.dataset.lpKeyboard) return;
      list.dataset.lpKeyboard = 'true';
      list.addEventListener('keydown', event => {
        const buttons = [...list.querySelectorAll('[role=tab]')];
        const index = buttons.indexOf(document.activeElement);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus(); buttons[next].click();
      });
    });
    scope.querySelectorAll('.lp-textura').forEach(section => {
      const track = section.querySelector('.lp-textura-carrossel');
      section.querySelectorAll('[data-scroll]').forEach(button => {
        if (button.dataset.lpBound) return;
        button.dataset.lpBound = 'true';
        button.addEventListener('click', () => track.scrollBy({left: Number(button.dataset.scroll) * (track.querySelector('.lp-textura-slide').getBoundingClientRect().width + 15), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
      });
    });
    // The Figma mobile viewport starts with Just and the two-display kit centered.
    scope.querySelectorAll('.lp-sab-carrossel,.lp-of-tiers').forEach(track => {
      if (track.dataset.lpPositioned) return;
      track.dataset.lpPositioned = 'true';
      const center = () => {
        if (matchMedia('(min-width:750px)').matches) {track.scrollTo({left:0,behavior:'instant'});return;}
        const child = track.children[track.classList.contains('lp-of-tiers') ? 1 : 2];
        if (child) track.scrollTo({left: child.offsetLeft - (track.clientWidth - child.offsetWidth) / 2, behavior: 'instant'});
      };
      requestAnimationFrame(center);
      const observer = new ResizeObserver(center); observer.observe(track);
    });
    scope.querySelectorAll('.lp-textura-carrossel,.lp-sab-carrossel,.lp-of-tiers').forEach(track => {
      if (track.dataset.lpDragBound) return;
      track.dataset.lpDragBound = 'true';
      let start = null, dragged = false;
      track.addEventListener('pointerdown', event => {
        if (track.classList.contains('lp-textura-carrossel') && matchMedia('(min-width:750px)').matches) return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        start = {x:event.clientX, scroll:track.scrollLeft, snap:track.style.scrollSnapType}; dragged = false;
        track.style.scrollSnapType = 'none';
      });
      track.addEventListener('pointermove', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        if (Math.abs(dx) > 6) dragged = true;
        if (dragged) { event.preventDefault(); track.scrollTo({left:start.scroll-dx,behavior:'instant'}); }
      });
      const end = () => {
        if (start) track.style.scrollSnapType = start.snap;
        start = null;
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', event => {if (dragged) {event.preventDefault();event.stopPropagation();dragged=false;}},true);
      track.addEventListener('dragstart',event=>event.preventDefault());
    });
    scope.querySelectorAll('.lp-menu').forEach(menu => {
      if (menu.dataset.lpBound) return;
      menu.dataset.lpBound = 'true';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.open = false));
      menu.addEventListener('keydown', event => {if (event.key === 'Escape') {menu.open = false;menu.querySelector('summary').focus();}});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
